/**
 * Chapter flow-diagram manifest.
 *
 * Maps each chapter number to its illustrated flagship-workflow diagram (PNG)
 * and a short caption (the flagship section + clause it depicts).
 *
 * Bundlers (Vite / CRA / Next.js / Readdy.ai) resolve these `import`s to the
 * correct hashed asset URL at build time. If you host the PNGs from a CDN or
 * /public folder instead, replace each `import` with a string URL, e.g.
 *   1: { src: "/assets/firecode/chapter01_flow.png", caption: "…" }
 *
 * Pass this object to <FireCodeWorkflowViewer diagrams={diagrams} />.
 */
import ch01 from "./chapter01_flow.png";
import ch02 from "./chapter02_flow.png";
import ch03 from "./chapter03_flow.png";
import ch04 from "./chapter04_flow.png";
import ch05 from "./chapter05_flow.png";
import ch06 from "./chapter06_flow.png";
import ch07 from "./chapter07_flow.png";
import ch08 from "./chapter08_flow.png";
import ch09 from "./chapter09_flow.png";
import ch10 from "./chapter10_flow.png";
import ch11 from "./chapter11_flow.png";

export const diagrams = {
  1: { src: ch01, caption: "Key Definitions Driving Downstream Decisions (Clause 1.4)" },
  2: { src: ch02, caption: "Means of Escape Requirements (Clause 2.3)" },
  3: { src: ch03, caption: "Surface Spread of Flame, Roofs & Construction Materials (Cl. 3.13–3.15)" },
  4: { src: ch04, caption: "Fire Access Openings to Buildings (Clause 4.2.3)" },
  5: { src: ch05, caption: "Primary & Secondary Power Supplies for Fire Safety Systems (Clause 5.2.1)" },
  6: { src: ch06, caption: "Fire Sprinkler Installation (Clause 6.4)" },
  7: { src: ch07, caption: "Air-Conditioning & Mechanical Ventilation Systems (Clause 7.1)" },
  8: { src: ch08, caption: "Exit Signs, Directional Signs & Photoluminescent Markings (Cl. 8.1.7–8.1.8)" },
  9: { src: ch09, caption: "PG VIII — Storage / General: Warehouses, Car Parks, FAMCPs (Clause 9.8)" },
  10: { src: ch10, caption: "Solar Photovoltaic (PV) Installations (Clause 10.2)" },
  11: { src: ch11, caption: "Certification Bodies — Requirements & Responsibilities (Clause 11.4)" },
};

export default diagrams;
